(function(root, factory) {
    if ('object' == typeof exports && 'object' == typeof module) module.exports = factory();
    else if ('function' == typeof define && define.amd) define([], factory);
    else if ('object' == typeof exports) exports["RealseeTelemetry"] = factory();
    else root["RealseeTelemetry"] = factory();
})(globalThis, ()=>(()=>{
        var __webpack_modules__ = {
            "./node_modules/ric-shim/index.js" (module1) {
                var fallback = function(cb) {
                    return setTimeout(function() {
                        var start = Date.now();
                        cb({
                            didTimeout: false,
                            timeRemaining: function() {
                                return Math.max(0, 50 - (Date.now() - start));
                            }
                        });
                    }, 1);
                };
                var isSupported = "u" > typeof requestIdleCallback;
                module1.exports = isSupported ? requestIdleCallback : fallback;
                module1.exports.cancelIdleCallback = isSupported ? cancelIdleCallback : clearTimeout;
            }
        };
        var __webpack_module_cache__ = {};
        function __webpack_require__(moduleId) {
            var cachedModule = __webpack_module_cache__[moduleId];
            if (void 0 !== cachedModule) return cachedModule.exports;
            var module1 = __webpack_module_cache__[moduleId] = {
                exports: {}
            };
            __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            return module1.exports;
        }
        (()=>{
            __webpack_require__.n = (module1)=>{
                var getter = module1 && module1.__esModule ? ()=>module1['default'] : ()=>module1;
                __webpack_require__.d(getter, {
                    a: getter
                });
                return getter;
            };
        })();
        (()=>{
            __webpack_require__.d = (exports1, definition)=>{
                for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
                    enumerable: true,
                    get: definition[key]
                });
            };
        })();
        (()=>{
            __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        })();
        (()=>{
            __webpack_require__.r = (exports1)=>{
                if ("u" > typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
                    value: 'Module'
                });
                Object.defineProperty(exports1, '__esModule', {
                    value: true
                });
            };
        })();
        var __webpack_exports__ = {};
        (()=>{
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, {
                setConfig: ()=>setConfig,
                EnvEnum: ()=>EnvEnum_EnvEnum,
                RealseeTelemetry: ()=>RealseeTelemetry,
                setVrCode: ()=>setVrCode,
                setCustomData: ()=>setCustomData,
                pushSDKEvent: ()=>pushSDKEvent,
                getSyncInstance: ()=>getSyncInstance,
                RealseeTelemetryConfig: ()=>RealseeTelemetry_namespaceObject.RealseeTelemetryConstructor,
                pushEvent: ()=>pushEvent
            });
            var RealseeTelemetry_namespaceObject = {};
            __webpack_require__.r(RealseeTelemetry_namespaceObject);
            __webpack_require__.d(RealseeTelemetry_namespaceObject, {
                D: ()=>RealseeTelemetry
            });
            function getSafeWindow() {
                if ("u" < typeof window) return {};
                return window;
            }
            const safeWindow_win = getSafeWindow();
            class Subscribe {
                $$REALSEE_TELEMETRY_EVENT$$ = {};
                get events() {
                    return this.$$REALSEE_TELEMETRY_EVENT$$;
                }
                set events(value) {
                    this.$$REALSEE_TELEMETRY_EVENT$$ = value;
                }
                hasListener = (name)=>Boolean(this.events[name]?.length);
                on = (name, callback, once = false)=>{
                    (this.events[name] ||= []).push([
                        callback,
                        once
                    ]);
                    return ()=>this.off(name, callback);
                };
                once = (name, callback)=>this.on(name, callback, true);
                off = (name, callback)=>{
                    if (!name) {
                        this.events = {};
                        return true;
                    }
                    if (!callback) {
                        delete this.events[name];
                        return true;
                    }
                    const index = this.events[name]?.findIndex(([cb])=>cb === callback);
                    if (-1 !== index) this.events[name].splice(index, 1);
                    return true;
                };
                emit = (name, ...data)=>{
                    const events = this.events[name] || [];
                    for (const [callback, once] of events.slice()){
                        const result = callback(...data);
                        if (once) this.off(name, callback);
                        if (false === result) return false;
                    }
                    return true;
                };
            }
            class RobustWebSocket extends Subscribe {
                _realWebSocket;
                _url;
                _protocols;
                _options = {
                    timeout: 10000,
                    shouldReconnect: (event, ws)=>{
                        if (1008 === event.code || 1011 === event.code) return;
                        return [
                            0,
                            3000,
                            10000
                        ][ws.attempts];
                    },
                    should1000Reconnect: false,
                    ignoreConnectivityEvents: false,
                    automaticOpen: false
                };
                _connectTimeout;
                _attempts = 0;
                _reconnects = -1;
                _reconnectWhenOnlineAgain = false;
                _explicitlyClosed = false;
                _pendingReconnect;
                _connectivityEventsAttached = false;
                _isReconnecting = false;
                get attempts() {
                    return this._attempts;
                }
                constructor(options){
                    super();
                    if (options) this.setOptions(options);
                }
                setOptions(options) {
                    if (!options) return;
                    this._url = options.url;
                    this._protocols = options.protocols;
                    const opts = Object.assign(this._options, options.robustOptions || {});
                    if ('number' != typeof opts?.timeout) throw new Error('timeout must be the number of milliseconds to timeout a connection attempt');
                    if ('function' != typeof opts?.shouldReconnect) throw new Error('shouldReconnect must be a function that returns the number of milliseconds to wait for a reconnect attempt, or null or undefined to not reconnect.');
                    this._options = opts;
                    if (this._options.automaticOpen) this._createWebSocket();
                }
                _clearPendingReconnectIfNeeded = ()=>{
                    if (this._pendingReconnect) {
                        clearTimeout(this._pendingReconnect);
                        this._pendingReconnect = void 0;
                    }
                };
                _online = (event)=>{
                    if (this._reconnectWhenOnlineAgain) {
                        this._clearPendingReconnectIfNeeded();
                        this._reconnect(event);
                    }
                };
                _offline = ()=>{
                    this._reconnectWhenOnlineAgain = true;
                    this._realWebSocket?.close(1000);
                };
                _detachConnectivityEvents = ()=>{
                    if (this._connectivityEventsAttached) {
                        safeWindow_win.removeEventListener('online', this._online);
                        safeWindow_win.removeEventListener('offline', this._offline);
                        this._connectivityEventsAttached = false;
                    }
                };
                _attachConnectivityEvents = ()=>{
                    if (!this._connectivityEventsAttached) {
                        safeWindow_win.addEventListener('online', this._online);
                        safeWindow_win.addEventListener('offline', this._offline);
                        this._connectivityEventsAttached = true;
                    }
                };
                send = (data)=>{
                    if (this._realWebSocket?.readyState === this._realWebSocket?.OPEN) this._realWebSocket?.send(data);
                };
                close = (code, reason)=>{
                    if ('number' != typeof code) {
                        reason = code;
                        code = 1000;
                    }
                    this._clearPendingReconnectIfNeeded();
                    this._reconnectWhenOnlineAgain = false;
                    this._explicitlyClosed = true;
                    this._detachConnectivityEvents();
                    return this._realWebSocket?.close(code, reason);
                };
                open = (url)=>{
                    if (url) this._url = url;
                    if (this._realWebSocket?.readyState !== WebSocket.OPEN && this._realWebSocket?.readyState !== WebSocket.CONNECTING) {
                        this._clearPendingReconnectIfNeeded();
                        this._reconnectWhenOnlineAgain = false;
                        this._explicitlyClosed = false;
                        this._createWebSocket();
                    }
                };
                _createWebSocket = ()=>{
                    const newUrl = 'string' == typeof this._url ? this._url : this._url?.(this);
                    if (!newUrl) return;
                    this._pendingReconnect = void 0;
                    this._removeWebSocketEvent();
                    this._realWebSocket = new WebSocket(newUrl, this._protocols || void 0);
                    this._attempts = this._attempts + 1;
                    this.emit('connecting', new CustomEvent('connecting', {
                        detail: {
                            attempts: this._attempts,
                            reconnects: this._reconnects
                        }
                    }));
                    const timeoutCallback = ()=>{
                        this._connectTimeout = void 0;
                        this._detachConnectivityEvents();
                        this.emit('timeout', new CustomEvent('timeout', {
                            detail: {
                                attempts: this._attempts,
                                reconnects: this._reconnects
                            }
                        }));
                    };
                    this._connectTimeout = setTimeout(timeoutCallback, this._options?.timeout);
                    this._dispatchWebSocketEvent();
                    if (!this._options?.ignoreConnectivityEvents) this._attachConnectivityEvents();
                };
                _removeWebSocketEvent = ()=>{
                    this._realWebSocket?.removeEventListener('open', this._webSocketOpenHandler);
                    this._realWebSocket?.removeEventListener('close', this._webSocketCloseHandler);
                    this._realWebSocket?.removeEventListener('error', this._webSocketErrorHandler);
                    this._realWebSocket?.removeEventListener('message', this._webSocketMessageHandler);
                };
                _dispatchWebSocketEvent = ()=>{
                    this._realWebSocket?.addEventListener('open', this._webSocketOpenHandler);
                    this._realWebSocket?.addEventListener('close', this._webSocketCloseHandler);
                    this._realWebSocket?.addEventListener('error', this._webSocketErrorHandler);
                    this._realWebSocket?.addEventListener('message', this._webSocketMessageHandler);
                };
                _webSocketOpenHandler = (event)=>{
                    if (this._connectTimeout) {
                        clearTimeout(this._connectTimeout);
                        this._connectTimeout = void 0;
                    }
                    const reconnects = ++this._reconnects;
                    const attempts = this._attempts;
                    this._attempts = 0;
                    this._reconnectWhenOnlineAgain = false;
                    return this.emit('open', Object.assign(event, {
                        detail: {
                            reconnects,
                            attempts
                        }
                    }));
                };
                _webSocketCloseHandler = (event)=>{
                    this._reconnect(event);
                    return this.emit('close', event);
                };
                _webSocketErrorHandler = (event)=>this.emit('error', new CustomEvent('error', {
                        detail: {
                            error: event
                        }
                    }));
                _webSocketMessageHandler = (event)=>this.emit('message', event);
                _reconnect(event) {
                    if (this._isReconnecting) return;
                    if (!this._options?.should1000Reconnect && 1000 === event.code || this._explicitlyClosed) {
                        this._attempts = 0;
                        return;
                    }
                    if (safeWindow_win.navigator?.onLine === false) {
                        this._reconnectWhenOnlineAgain = true;
                        return;
                    }
                    const delay = this._options?.shouldReconnect?.(event, this);
                    if ('number' == typeof delay) {
                        this._isReconnecting = true;
                        this._pendingReconnect = setTimeout(()=>{
                            this._createWebSocket();
                            this._isReconnecting = false;
                        }, delay);
                    }
                }
            }
            var EnvEnum_EnvEnum = /*#__PURE__*/ function(EnvEnum) {
                EnvEnum["Development"] = "development";
                EnvEnum["Test"] = "test";
                EnvEnum["Preview"] = "preview";
                EnvEnum["Production"] = "production";
                EnvEnum["Sandbox"] = "sandbox";
                return EnvEnum;
            }({});
            const parse = (cookie)=>{
                const result = {};
                const cookies = cookie.split(';').filter(Boolean);
                for (const item of cookies){
                    const [key, value] = item.split('=');
                    if (null != key && '' !== key) result[`${key}`.trim()] = `${value}`.trim();
                }
                return result;
            };
            const getCookie = (name)=>{
                const cookies = parse(getSafeWindow()?.document?.cookie ?? '');
                return cookies[name];
            };
            const deviceDetect_userAgent = safeWindow_win.navigator?.userAgent;
            const isMiniprogram = /micromessenger/i.test(deviceDetect_userAgent) && /miniprogram/i.test(deviceDetect_userAgent);
            const isIOS = /iphone|ipad/i.test(deviceDetect_userAgent);
            const isAndroid = /android/i.test(deviceDetect_userAgent);
            const isApp = isIOS || isAndroid;
            const isRealseeSDK = isApp && /realsee\s*([0-9a-z]+)/i.test(deviceDetect_userAgent);
            isMiniprogram && /realsee\s*([0-9a-z]+)/i.test(deviceDetect_userAgent);
            const getTime = (now = new Date())=>`${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')} ${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}.${now.getMilliseconds().toString().padStart(3, '0')}`;
            const echo = (logLevel, ...args)=>{
                const logParams = [
                    `Realsee [${getTime()}] <${logLevel}> `,
                    ...args
                ];
                if ("ERROR" === logLevel) console.error(...logParams);
                else if ("WARN" === logLevel) console.warn(...logParams);
                else if ("INFO" === logLevel) console.info(...logParams);
                else console.log(...logParams);
            };
            const logger = {
                log: (...args)=>echo("LOG", ...args),
                info: (...args)=>echo("INFO", ...args),
                error: (...args)=>echo("ERROR", ...args),
                warn: (...args)=>echo("WARN", ...args)
            };
            const parseTerminal = (userAgent = '')=>{
                const isRealseeVRWebvieew = /realsee/gi.test(userAgent);
                const isWechatBroswer = /micromessenger/gi.test(userAgent) && !/miniprogram/gi.test(userAgent);
                const isWechatMiniprogram = /micromessenger/gi.test(userAgent) && !/miniprogram/gi.test(userAgent);
                if (isWechatMiniprogram) return 'wechatMiniprogram';
                if (isWechatBroswer) return 'wechatBroswer';
                if (isRealseeVRWebvieew) return 'realseeVRWebvieew';
                return 'broswer';
            };
            const S4 = ()=>((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
            function uuid() {
                return `${S4()}${S4()}-${S4()}-4${S4().substring(0, 3)}-${S4()}-${S4()}${S4()}${S4()}`.toLowerCase();
            }
            var ric_shim = __webpack_require__("./node_modules/ric-shim/index.js");
            var ric_shim_default = /*#__PURE__*/ __webpack_require__.n(ric_shim);
            function getIntegerTimestamp() {
                if ('function' == typeof safeWindow_win.performance?.now) return Math.floor(safeWindow_win.performance.now());
                const navStart = safeWindow_win.performance?.timing?.navigationStart || safeWindow_win.performance?.timeOrigin || Date.now() - 100;
                return Date.now() - navStart;
            }
            function getPerformanceTimestamp() {
                if ('function' == typeof safeWindow_win.performance?.now) return Math.floor(safeWindow_win.performance.now());
                return null;
            }
            const getBaseUrl = (params)=>{
                const endpointUri = `/endpoint/v1?open_app_id=${params.appKey}&real_uri=single/v1/websocket`;
                const _protocol = params.customOptions?.protocol || 'wss';
                const _host = (()=>{
                    if (params.customOptions?.host) return params.customOptions.host;
                    if (params.i18n) return 'ws-access.realsee.jp';
                    const prefix = 'production' !== params.env ? 'sandbox-' : '';
                    const [com] = safeWindow_win.location?.hostname?.split('.').reverse() || [];
                    const suffix = (()=>{
                        if ('com' === com) return 'com';
                        return 'cn';
                    })();
                    const withCommerce = '' === prefix ? '-commerce' : '';
                    return `${prefix}ws-access${withCommerce}.realsee.${suffix}`;
                })();
                const _port = params.customOptions?.port;
                const base = `${_protocol}://${_host}`;
                if ('number' == typeof _port) {
                    if (80 === _port && 'ws' === _protocol || 443 === _port && 'wss' === _protocol) return `${base}${endpointUri}`;
                    return `${base}:${_port}${endpointUri}`;
                }
                return `${base}${endpointUri}`;
            };
            const __Realsee_Telemetry_Storage_Key__ = '__Realsee_Telemetry_Storage__';
            const __Realsee_Telemetry_Client_Id_Expired__ = 315360000000;
            class Controller {
                _sessionData;
                _code = '';
                _appKey = '';
                _ws;
                _messageQueue = [];
                _pushTimer = 0;
                _options;
                _rstpsid = null;
                _canPush = false;
                _lastRuntime = void 0;
                _eventQueue = [];
                _isProcessingQueue = false;
                constructor(opts){
                    this.options = opts;
                }
                set options(opts) {
                    if (opts) {
                        this._options = {
                            env: opts.env || EnvEnum_EnvEnum.Production,
                            i18n: opts.i18n ?? false,
                            enableFps: opts.enableFps ?? false,
                            fpsInterval: opts.fpsInterval ?? 5,
                            fpsThreshold: opts.fpsThreshold ?? 55,
                            reportQps: opts.reportQps ?? 5,
                            reportQpsMap: opts.reportQpsMap ?? {},
                            enableQpsLog: opts.enableQpsLog ?? true,
                            eventsWithFullSession: opts.eventsWithFullSession ?? [],
                            retry: opts.retry ?? 3,
                            retryInterval: opts.retryInterval ?? 3,
                            disabled: opts.disabled ?? false,
                            vrCode: opts.vrCode ?? '',
                            appKey: opts.appKey ?? '',
                            query: opts.query ?? {},
                            data: opts.data ?? {},
                            onReceiveMessage: opts.onReceiveMessage ?? (()=>void 0),
                            customWebsocketEndpointOptions: opts.customWebsocketEndpointOptions ?? {}
                        };
                        this._init(opts);
                    }
                }
                get options() {
                    return this._options;
                }
                set appKey(appKey) {
                    if (!this._appKey) {
                        this._appKey = appKey;
                        this._initWs(appKey);
                    }
                }
                set sessionData(sessionData) {
                    this._sessionData = sessionData;
                }
                get sessionData() {
                    return this._initSessionData(this.options);
                }
                getSessionData = (innerEventName)=>{
                    const sessionData = this._initSessionData(this.options);
                    if (this.options?.eventsWithFullSession?.includes(innerEventName)) sessionData.runtime = this._runtime;
                    return sessionData;
                };
                _init = (options)=>{
                    if (options.disabled) return;
                    this.sessionData = this._initSessionData(options);
                    this._code = options.vrCode || '';
                    if (options.appKey) this.appKey = options.appKey;
                };
                get _localStorage() {
                    const storage = safeWindow_win.localStorage?.getItem(__Realsee_Telemetry_Storage_Key__);
                    if (!storage) return null;
                    try {
                        return JSON.parse(storage);
                    } catch  {
                        return null;
                    }
                }
                set _localStorage(storage) {
                    if ('object' == typeof storage) safeWindow_win.localStorage?.setItem(__Realsee_Telemetry_Storage_Key__, JSON.stringify(storage));
                    else safeWindow_win.localStorage?.removeItem(__Realsee_Telemetry_Storage_Key__);
                }
                get _sessionStorage() {
                    const storage = safeWindow_win.sessionStorage?.getItem(__Realsee_Telemetry_Storage_Key__);
                    if (!storage) return null;
                    try {
                        return JSON.parse(storage);
                    } catch  {
                        return null;
                    }
                }
                set _sessionStorage(storage) {
                    if ('object' == typeof storage) safeWindow_win.sessionStorage?.setItem(__Realsee_Telemetry_Storage_Key__, JSON.stringify(storage));
                    else safeWindow_win.sessionStorage?.removeItem(__Realsee_Telemetry_Storage_Key__);
                }
                get _clientId() {
                    const storage = this._localStorage;
                    if (storage) {
                        const ts = storage.__Realsee_Telemetry_Client_Id_Ts__;
                        const id = storage.__Realsee_Telemetry_Client_Id__;
                        if (id && 'number' == typeof ts && Date.now() - ts < __Realsee_Telemetry_Client_Id_Expired__) return id;
                    }
                    const id = uuid();
                    this._localStorage = Object.assign(storage || {}, {
                        __Realsee_Telemetry_Client_Id__: id,
                        __Realsee_Telemetry_Client_Id_Ts__: Date.now()
                    });
                    return id;
                }
                get _sessionId() {
                    const storage = this._sessionStorage;
                    if (storage) {
                        const id = storage.__Realsee_Telemetry_Session_Id__;
                        if (id) return id;
                    }
                    const id = uuid().replace(/-/gi, '');
                    this._sessionStorage = Object.assign(storage || {}, {
                        __Realsee_Telemetry_Session_Id__: id
                    });
                    return id;
                }
                get _parentSessionId() {
                    return this._rstpsid ?? this._parseParentSessionId();
                }
                get _lianjiaUUID() {
                    return getCookie('lianjia_uuid') ?? '';
                }
                _parseParentSessionId() {
                    const search = safeWindow_win.location?.search || '';
                    const query = search.replace('?', '').split('&').map((kv)=>kv.split('=')).map((kv)=>({
                            [kv[0]]: decodeURIComponent(kv[1])
                        })).reduce((obj, curr)=>({
                            ...obj,
                            ...curr
                        }), {});
                    this._rstpsid = query?.rstpsid ?? '';
                    return this._rstpsid;
                }
                get _runtime() {
                    const ua = safeWindow_win.navigator?.userAgent;
                    return {
                        terminal: parseTerminal(ua),
                        userAgent: ua,
                        platform: safeWindow_win.navigator?.platform || (()=>{
                            if (isIOS) return 'ios';
                            if (isAndroid) return 'android';
                            if (isMiniprogram) return 'wxMiniProgram';
                            return 'unknown';
                        })(),
                        isVRWebView: isRealseeSDK,
                        performance: safeWindow_win.performance?.timing?.toJSON(),
                        navigator: {
                            appCodeName: safeWindow_win.navigator?.appCodeName,
                            appName: safeWindow_win.navigator?.appName,
                            appVersion: safeWindow_win.navigator?.appVersion,
                            hardwareConcurrency: safeWindow_win.navigator?.hardwareConcurrency,
                            language: safeWindow_win.navigator?.language,
                            maxTouchPoints: safeWindow_win.navigator?.maxTouchPoints,
                            product: safeWindow_win.navigator?.product,
                            productSub: safeWindow_win.navigator?.productSub,
                            vendor: safeWindow_win.navigator?.vendor,
                            vendorSub: safeWindow_win.navigator?.vendorSub
                        },
                        screen: {
                            availHeight: safeWindow_win.screen?.availHeight,
                            availWidth: safeWindow_win.screen?.availWidth,
                            colorDepth: safeWindow_win.screen?.colorDepth,
                            height: safeWindow_win.screen?.height,
                            width: safeWindow_win.screen?.width,
                            pixelDepth: safeWindow_win.screen?.pixelDepth
                        },
                        viewport: {
                            innerWidth: safeWindow_win.innerWidth,
                            innerHeight: safeWindow_win.innerHeight,
                            outerWidth: safeWindow_win.outerWidth,
                            outerHeight: safeWindow_win.outerHeight,
                            devicePixelRatio: safeWindow_win.devicePixelRatio
                        },
                        docment: {
                            referrer: safeWindow_win.document?.referrer,
                            characterSet: safeWindow_win.document?.characterSet,
                            compatMode: safeWindow_win.document?.compatMode,
                            contentType: safeWindow_win.document?.contentType
                        }
                    };
                }
                hasRuntimeChange = (last, curr)=>{
                    if (!last) return true;
                    return Object.keys(curr).some((key)=>{
                        if ('object' == typeof curr[key]) return Object.keys(curr[key]).some((k)=>curr[key][k] !== last[key][k]);
                        return curr[key] !== last[key];
                    });
                };
                _initSessionData = (options)=>{
                    const sessionData = {
                        env: options?.env || EnvEnum_EnvEnum.Production,
                        custom: {
                            query: options?.query,
                            data: options?.data
                        },
                        url: safeWindow_win.location?.href
                    };
                    if (this.hasRuntimeChange(this._lastRuntime, this._runtime)) {
                        this._lastRuntime = this._runtime;
                        sessionData.runtime = this._runtime;
                    }
                    return sessionData;
                };
                set code(code) {
                    this._code = code;
                }
                get code() {
                    return this._code;
                }
                get customData() {
                    return this._sessionData?.custom?.data;
                }
                set customData(data) {
                    if (this._sessionData?.custom?.data) this._sessionData.custom.data = data;
                    else logger.warn('cannot set customData because session uninitialized');
                }
                _initWs = (appKey)=>{
                    const baseUrl = getBaseUrl({
                        env: this._sessionData.env,
                        appKey,
                        i18n: this._options?.i18n,
                        customOptions: this._options?.customWebsocketEndpointOptions
                    });
                    const customQuery = this._sessionData.custom?.query || {};
                    const queryString = Object.keys(customQuery).map((key)=>`${key}=${encodeURIComponent(customQuery[key])}`).join('&');
                    const wsUrl = baseUrl + `${queryString ? '&' + queryString : ''}`;
                    this._ws = new RobustWebSocket();
                    this._bindEvent();
                    this._ws.open(wsUrl);
                };
                _bindEvent() {
                    this._ws.on('close', this._handleClose);
                    this._ws.on('connecting', this._handleConnecting);
                    this._ws.on('error', this._handleError);
                    this._ws.on('open', this._handleOpen);
                    this._ws.on('timeout', this._handleTimeout);
                }
                _handleClose = ()=>{
                    logger.info('RealseeTelemetry close');
                };
                _handleConnecting = ()=>{
                    logger.info('RealseeTelemetry connecting');
                };
                _handleError = (event)=>{
                    logger.info('RealseeTelemetry error', event);
                };
                _handleMessage = (event)=>{
                    let message = event.data;
                    try {
                        message = JSON.parse(message);
                    } catch  {
                        logger.warn('invalid ws message');
                    }
                    if ('object' == typeof message) {
                        const data = message;
                        this._handlePullMessage(event);
                        if (0 === data.code && 7 === data.command) {
                            this._canPush = true;
                            this._startPush();
                            this._startPull();
                            return;
                        }
                    }
                    this._canPush = false;
                    this._stopPush();
                    this._stopPull();
                };
                _handleOpen = ()=>{
                    logger.info('RealseeTelemetry open');
                    this._ws.once('message', this._handleMessage);
                };
                _handleTimeout = ()=>{
                    logger.info('RealseeTelemetry timeout');
                };
                _unbindEvent = ()=>{
                    this._ws.off('close', this._handleClose);
                    this._ws.off('connecting', this._handleConnecting);
                    this._ws.off('error', this._handleError);
                    this._ws.off('message', this._handleMessage);
                    this._ws.off('open', this._handleOpen);
                    this._ws.off('timeout', this._handleTimeout);
                };
                _sendEvent = ()=>{
                    const data = this._messageQueue.pop();
                    if (data) this._ws.send(JSON.stringify({
                        command: 20,
                        data
                    }));
                    this._pushTimer = ric_shim_default()(this._sendEvent);
                };
                _startPush = ()=>{
                    if (!this._canPush) return;
                    logger.info('RealseeTelemetry start push');
                    this._clearPushTimerIfNeed();
                    if (this._messageQueue.length > 0) this._pushTimer = ric_shim_default()(this._sendEvent);
                };
                _stopPush = ()=>{
                    logger.info('RealseeTelemetry stop push');
                    this._clearPushTimerIfNeed();
                };
                _startPull = ()=>{
                    logger.info('RealseeTelemetry start pull');
                    this._ws.on('message', this._handlePullMessage);
                };
                _stopPull = ()=>{
                    logger.info('RealseeTelemetry stop pull');
                    this._ws.off('message', this._handlePullMessage);
                };
                _handlePullMessage = (event)=>{
                    let message = event.data;
                    try {
                        message = JSON.parse(message);
                    } catch  {
                        logger.warn('invalid ws message');
                    }
                    if ('object' == typeof message) {
                        const data = message;
                        this.options?.onReceiveMessage?.(data);
                    }
                };
                _clearPushTimerIfNeed = ()=>{
                    if (this._pushTimer) {
                        (0, ric_shim.cancelIdleCallback)(this._pushTimer);
                        this._pushTimer = 0;
                    }
                };
                eventTimestamps = {};
                async _retryOperation(operation, retries = 3, delay = 1000) {
                    try {
                        return await operation();
                    } catch (error) {
                        if (retries > 0) {
                            await new Promise((resolve)=>setTimeout(resolve, delay));
                            return this._retryOperation(operation, retries - 1, 2 * delay);
                        }
                        throw error;
                    }
                }
                pushEvent = async (event)=>{
                    await this._retryOperation(async ()=>{
                        const _reportQps = this.options?.reportQps;
                        const _reportQpsMap = this.options?.reportQpsMap;
                        const _enableQpsLog = this.options?.enableQpsLog ?? true;
                        const _eventName = (()=>{
                            switch(event.source){
                                case "sdk":
                                    {
                                        const _event = event;
                                        if ('@realsee/five' === _event.sdk.pkg) {
                                            if ('fps' === _event.name) return _event.name;
                                            return `five.${_event.name}`;
                                        }
                                        if ('@realsee/dnalogel' === _event.sdk.pkg) return `dnalogel-${_event.sdk.name}.${_event.name}`;
                                        return event.name ?? event.id ?? '';
                                    }
                                case "custom":
                                    return `custom.${event.id}`;
                                default:
                                    return event.name || '';
                            }
                        })();
                        if (_eventName) {
                            const _qps = _reportQpsMap?.[_eventName] ?? _reportQps;
                            if (_qps) {
                                const _now = Date.now();
                                if (!this.eventTimestamps[_eventName]) this.eventTimestamps[_eventName] = [];
                                this.eventTimestamps[_eventName].push(_now);
                                this.eventTimestamps[_eventName] = this.eventTimestamps[_eventName].filter((ts)=>_now - ts < 1000);
                                if (this.eventTimestamps[_eventName].length <= _qps) {
                                    const message = this._makeWebsocketCommandData(event, _eventName);
                                    this._messageQueue.push(message);
                                    if (!this._pushTimer) this._startPush();
                                } else {
                                    if (_enableQpsLog) logger.warn(`⚠️事件${_eventName}，命中 qps ${_qps} 限制，被丢弃⚠️)`);
                                    return;
                                }
                            }
                        }
                    });
                };
                _makeWebsocketCommandData = (event, innerEventName)=>{
                    const ts = Date.now();
                    const data = {
                        event,
                        code: this._code,
                        cid: this._clientId,
                        psid: this._parentSessionId,
                        sid: this._sessionId,
                        rid: uuid(),
                        ts,
                        uuid: this._lianjiaUUID
                    };
                    const performanceTimestamp = getPerformanceTimestamp();
                    if (null !== performanceTimestamp) data.ps = performanceTimestamp;
                    data.session = this.getSessionData(innerEventName);
                    data.session.url = safeWindow_win.location?.href;
                    const getByteLength = (str)=>new TextEncoder().encode(str).length;
                    const dataSize = getByteLength(JSON.stringify(data));
                    if (dataSize > 4000) {
                        logger.warn(`数据大小(${dataSize}字节)超过4KB限制，将进行裁剪`);
                        if (data.session?.runtime) {
                            const runtime = data.session.runtime;
                            delete runtime.navigator;
                            delete runtime.performance;
                            const newSize = getByteLength(JSON.stringify(data));
                            if (newSize > 4000) {
                                delete data.session.runtime;
                                logger.warn('删除runtime信息后大小:', newSize, '字节');
                            }
                        }
                        if (getByteLength(JSON.stringify(data)) > 4000) {
                            delete data.session;
                            logger.warn('删除session信息后大小:', getByteLength(JSON.stringify(data)), '字节');
                        }
                    }
                    return data;
                };
                clearMessageQueue = ()=>{
                    this._messageQueue = [];
                };
                async _processEventQueue() {
                    if (this._isProcessingQueue) return;
                    this._isProcessingQueue = true;
                    while(this._eventQueue.length > 0){
                        const event = this._eventQueue.shift();
                        if (event) try {
                            await this._processEvent(event);
                        } catch (err) {
                            logger.error('Failed to process event:', err);
                        }
                    }
                    this._isProcessingQueue = false;
                }
                _processEvent(event) {
                    return new Promise((resolve, reject)=>{
                        try {
                            this.pushEvent(event);
                            resolve(true);
                        } catch (err) {
                            reject(err);
                        }
                    });
                }
                _cleanup() {
                    this._eventQueue = [];
                    if (this._pushTimer) {
                        (0, ric_shim.cancelIdleCallback)(this._pushTimer);
                        this._pushTimer = 0;
                    }
                    this._ws?.close();
                    this._unbindEvent();
                }
                dispose() {
                    this._cleanup();
                }
            }
            function omit(object, props) {
                const result = {};
                Object.keys(object).forEach((key)=>{
                    if (!props.includes(key)) Object.assign(result, {
                        [key]: object[key]
                    });
                });
                return result;
            }
            function throttle(func, wait = 200) {
                let last;
                let timer;
                let lastArgs;
                return function(...args) {
                    lastArgs = args;
                    if (last) {
                        if (!timer) timer = setTimeout(()=>{
                            if (void 0 !== last && Date.now() - last >= wait) {
                                func.apply(this, lastArgs || []);
                                last = Date.now();
                            }
                            if (timer) {
                                clearTimeout(timer);
                                timer = void 0;
                            }
                            lastArgs = void 0;
                        }, wait - (void 0 !== last ? Date.now() - last : 0));
                    } else {
                        func.apply(this, lastArgs || []);
                        last = Date.now();
                    }
                };
            }
            class RealseeTelemetry {
                _controller;
                _initFiveEventTimer = 0;
                logger = false;
                _defaultOptions = {
                    fpsInterval: 5,
                    fpsThreshold: 55,
                    autoInitFiveEvent: true
                };
                _eventResources = [];
                _maxFpsQueueSize = 1000;
                _fpsQueue = [];
                _fpsReportTimestamp = 0;
                constructor(options){
                    const opts = Object.assign({}, this._defaultOptions, options || {});
                    this._controller = new Controller(opts);
                    if (opts.autoInitFiveEvent && !this._initFiveEventTimer && !opts.disabled) this._initFiveEventTimer = ric_shim_default()(this._initFiveEvent);
                    if (opts.logger) this.logger = opts.logger;
                    if (opts.disabled) this._controller.clearMessageQueue();
                }
                set config(config) {
                    const opts = Object.assign({}, this._controller.options || {}, config);
                    if (opts.autoInitFiveEvent && !this._initFiveEventTimer && !opts.disabled) this._initFiveEventTimer = ric_shim_default()(this._initFiveEvent);
                    if (opts.logger) this.logger = opts.logger;
                    if (opts.disabled) this._controller.clearMessageQueue();
                }
                get customData() {
                    return this._controller.customData;
                }
                set customData(data) {
                    this._controller.customData = data;
                }
                set code(code) {
                    this._controller.code = code;
                }
                _createSafeEventHandler(target, eventName, handler, checkRenderer) {
                    const safeHandler = (...args)=>{
                        if (checkRenderer?.renderer) handler(...args);
                        else this._unbindEvent(target, eventName, safeHandler);
                    };
                    this._eventResources.push({
                        target,
                        eventName,
                        handler: safeHandler,
                        dispose: ()=>this._unbindEvent(target, eventName, safeHandler)
                    });
                    return safeHandler;
                }
                _bindEvent(target, eventName, handler) {
                    target?.on?.(eventName, handler);
                }
                _unbindEvent(target, eventName, handler) {
                    target?.off?.(eventName, handler);
                    const index = this._eventResources.findIndex((resource)=>resource.target === target && resource.eventName === eventName && resource.handler === handler);
                    if (-1 !== index) this._eventResources.splice(index, 1);
                }
                pushCustomEvent = (opts)=>{
                    try {
                        this._controller.pushEvent({
                            ...opts,
                            source: "custom"
                        });
                    } catch (e) {
                        if (this.logger) logger.warn(' RealseeTelemetry pushCustomEvent failed, cause by ', e.message);
                    }
                };
                pushSDKEvent = (opts)=>{
                    try {
                        this._controller.pushEvent({
                            id: opts.id || '',
                            ...opts,
                            source: "sdk"
                        });
                    } catch (e) {
                        if (this.logger) logger.warn(' RealseeTelemetry pushSDKEvent failed, cause by ', e.message);
                    }
                };
                _handleFpsData(fps, time, fiveSDKInfo) {
                    if (!this._controller.options?.enableFps) return;
                    if (this._controller.options?.fpsThreshold && fps >= this._controller.options?.fpsThreshold) return;
                    this._fpsQueue.push({
                        fps,
                        time
                    });
                    if (this._fpsQueue.length > this._maxFpsQueueSize) this._fpsQueue.shift();
                    const fpsInterval = 1000 * (this._controller.options?.fpsInterval || 5);
                    if (Date.now() - this._fpsReportTimestamp >= fpsInterval) {
                        const event = {
                            name: 'fps',
                            data: {
                                fps: this._fpsQueue.map((item)=>item.fps),
                                time: this._fpsQueue.map((item)=>item.time)
                            },
                            sdk: fiveSDKInfo
                        };
                        this.pushSDKEvent(event);
                        this._fpsQueue = [];
                        this._fpsReportTimestamp = Date.now();
                    }
                }
                _initFiveEvent = ()=>{
                    const isFiveExist = Object.keys(safeWindow_win.__FIVE_DEBUG__?.instances || {}).length >= 1;
                    if (isFiveExist) {
                        const fiveSDKInfo = {
                            pkg: '@realsee/five',
                            version: safeWindow_win.__FIVE_DEBUG__?.constructor?.version || 'unknown'
                        };
                        const pluginSDKInfo = {
                            pkg: '@realsee/dnalogel',
                            version: safeWindow_win?.__DNALOGEL_DEBUG__?.version || 'unknown',
                            type: 'plugin'
                        };
                        const handler = (eventName, eventData)=>{
                            const event = {
                                name: eventName,
                                data: eventData,
                                sdk: fiveSDKInfo
                            };
                            this.pushSDKEvent(event);
                        };
                        const fpsReport = (fps, time)=>{
                            this._handleFpsData(fps, time, fiveSDKInfo);
                        };
                        const fiveEventMap = {
                            panoSelected: (panoIndex)=>handler('panoSelected', {
                                    panoIndex
                                }),
                            moveToPano: (panoIndex, userAction)=>handler('moveToPano', {
                                    panoIndex,
                                    userAction
                                }),
                            moveToPanoCanceled: (panoIndex)=>handler('moveToPanoCanceled', {
                                    panoIndex
                                }),
                            panoWillArrive: (panoIndex, pose, userAction)=>handler('panoWillArrive', {
                                    panoIndex,
                                    pose,
                                    userAction
                                }),
                            panoArrived: (panoIndex, pose, userAction)=>handler('panoArrived', {
                                    panoIndex,
                                    pose,
                                    userAction
                                }),
                            panoWillLoad: (panoIndex)=>handler('panoWillLoad', {
                                    panoIndex
                                }),
                            textureStartLoad: (panoIndex)=>handler('textureStartLoad', {
                                    panoIndex
                                }),
                            textureAbort: (panoIndex)=>handler('textureAbort', {
                                    panoIndex
                                }),
                            textureError: (error, panoIndex)=>handler('textureError', {
                                    error: error.message || error.name,
                                    panoIndex
                                }),
                            textureLoaded: (panoIndex)=>handler('textureLoaded', {
                                    panoIndex
                                }),
                            panoLoaded: (panoIndex)=>handler('panoLoaded', {
                                    panoIndex
                                }),
                            panoLoadError: (error, panoIndex)=>handler('panoLoadError', {
                                    panoIndex,
                                    error: error.message
                                }),
                            error: (error)=>handler('error', {
                                    error: error.message
                                }),
                            willLoad: ()=>handler('willLoad', {}),
                            loaded: ()=>handler('loaded', {}),
                            modelBvhLoaded: ()=>handler('modelBvhLoaded', {}),
                            modelGeometryLoaded: ()=>handler('modelGeometryLoaded', {}),
                            modelMaterialLoaded: ()=>handler('modelMaterialLoaded', {}),
                            modelWillLoad: ()=>handler('modelWillLoad', {}),
                            modelLoadError: (error)=>handler('modelLoadError', {
                                    error: error.message
                                }),
                            modelLoaded: ()=>handler('modelLoaded', {}),
                            modelShownFloorChange: (shownFloor, totalFloorLength)=>handler('modelShownFloorChange', {
                                    shownFloor,
                                    totalFloorLength
                                }),
                            stateChange: throttle((state, userAction)=>handler('stateChange', {
                                    state,
                                    userAction
                                })),
                            setState: (state)=>handler('setState', {
                                    state
                                }),
                            stateSynced: (state)=>handler('stateSynced', {
                                    state
                                }),
                            modeChange: (mode, prevMode, panoIndex, toPose, userAction)=>handler('modeChange', {
                                    mode,
                                    prevMode,
                                    panoIndex,
                                    toPose,
                                    userAction
                                }),
                            dispose: ()=>handler('dispose'),
                            fps: (fps)=>fpsReport(fps, getIntegerTimestamp())
                        };
                        const fiveInstances = safeWindow_win.__FIVE_DEBUG__.instances;
                        Object.keys(fiveInstances).forEach((key)=>{
                            const five = fiveInstances[key];
                            if (!five?.renderer) return;
                            const workHandler = (_input, work)=>{
                                this.code = work.workCode;
                            };
                            const willLoadHandler = this._createSafeEventHandler(five, 'willLoad', (_input, work)=>workHandler(_input, work), five);
                            const loadedHandler = this._createSafeEventHandler(five, 'loaded', (_input, work)=>workHandler(_input, work), five);
                            this._bindEvent(five, 'willLoad', willLoadHandler);
                            this._bindEvent(five, 'loaded', loadedHandler);
                            Object.keys(fiveEventMap).forEach((eventName)=>{
                                const typedEventName = eventName;
                                const eventHandler = this._createSafeEventHandler(five, typedEventName, (...args)=>{
                                    const fn = fiveEventMap[typedEventName];
                                    fn(...args);
                                }, five);
                                this._bindEvent(five, typedEventName, eventHandler);
                            });
                            Object.keys(five.plugins || {}).forEach((pluginName)=>{
                                const plugin = five.plugins[pluginName];
                                if (plugin?.hooks) {
                                    const stateChangeHandler = this._createSafeEventHandler(plugin.hooks, 'stateChange', ({ state, userAction })=>{
                                        const info = Object.assign({}, pluginSDKInfo, {
                                            name: pluginName
                                        });
                                        const event = {
                                            name: 'stateChange',
                                            sdk: info,
                                            data: {
                                                state: omit(state, [
                                                    'config'
                                                ]),
                                                userAction
                                            },
                                            source: "sdk"
                                        };
                                        this.pushSDKEvent(event);
                                    }, five);
                                    this._bindEvent(plugin.hooks, 'stateChange', stateChangeHandler);
                                }
                            });
                            if (safeWindow_win.parent) {
                                const messageHandler = (message)=>{
                                    if (message.data?.from === 'realsee-telemetry-controller') {
                                        const { sdk, source, data, name } = message.data.event;
                                        if ("sdk" === source) {
                                            if ('@realsee/five' === sdk.pkg && [
                                                'stateSynced'
                                            ].includes(name) && five?.renderer) five.setState(data?.state, false, false);
                                            if ('@realsee/dnalogel' === sdk.pkg && [
                                                'stateChange'
                                            ].includes(name) && sdk.name && 'plugin' === sdk.type && five?.renderer) five?.plugins?.[sdk.name]?.setState?.(data?.state);
                                        }
                                    }
                                };
                                safeWindow_win.addEventListener('message', messageHandler, false);
                                this._eventResources.push({
                                    target: safeWindow_win,
                                    eventName: 'message',
                                    handler: messageHandler,
                                    dispose: ()=>safeWindow_win.removeEventListener('message', messageHandler, false)
                                });
                            }
                        });
                    } else this._initFiveEventTimer = ric_shim_default()(this._initFiveEvent);
                };
                dispose = ()=>{
                    if (this._initFiveEventTimer) {
                        (0, ric_shim.cancelIdleCallback)(this._initFiveEventTimer);
                        this._initFiveEventTimer = 0;
                    }
                    this._eventResources.forEach((resource)=>{
                        try {
                            resource.dispose();
                        } catch (err) {
                            if (this.logger) logger.warn('Failed to dispose event resource:', err);
                        }
                    });
                    this._eventResources = [];
                    this._fpsQueue = [];
                    this._controller.dispose?.();
                };
            }
            const instanceId = (()=>{
                if (safeWindow_win.__Realsee_Telemetry_Instance_Id__) return safeWindow_win.__Realsee_Telemetry_Instance_Id__;
                Object.assign(safeWindow_win, {
                    __Realsee_Telemetry_Instance_Id__: `__Realsee_Telemetry_Instance_${uuid()}__`
                });
                return safeWindow_win.__Realsee_Telemetry_Instance_Id__;
            })();
            let __Realsee_Telemetry_Instance__ = safeWindow_win[instanceId];
            let __Realsee_Telemetry_Config__ = safeWindow_win.__Realsee_Telemetry_Config__;
            const initRealseeTelemetryIfNeed = ()=>{
                if (!__Realsee_Telemetry_Instance__) __Realsee_Telemetry_Instance__ = safeWindow_win[instanceId] = new RealseeTelemetry(__Realsee_Telemetry_Config__);
            };
            const pushEvent = (params)=>{
                try {
                    initRealseeTelemetryIfNeed();
                    if (__Realsee_Telemetry_Instance__?.config?.disabled) return;
                    __Realsee_Telemetry_Instance__?.pushCustomEvent(params);
                } catch  {}
            };
            const pushSDKEvent = (params)=>{
                try {
                    initRealseeTelemetryIfNeed();
                    if (__Realsee_Telemetry_Instance__?.config?.disabled) return;
                    __Realsee_Telemetry_Instance__?.pushSDKEvent(params);
                } catch  {}
            };
            const setConfig = (config)=>{
                if (!config) return;
                __Realsee_Telemetry_Config__ = Object.assign(safeWindow_win.__Realsee_Telemetry_Config__ || {}, config || {});
                if (__Realsee_Telemetry_Instance__) __Realsee_Telemetry_Instance__.config = __Realsee_Telemetry_Config__;
                else initRealseeTelemetryIfNeed();
            };
            const setCustomData = (customData)=>{
                if (__Realsee_Telemetry_Instance__) __Realsee_Telemetry_Instance__.customData = customData;
            };
            const setVrCode = (code)=>{
                if (__Realsee_Telemetry_Instance__) __Realsee_Telemetry_Instance__.code = code;
            };
            const getSyncInstance = (params)=>{
                const instance = new RealseeTelemetry({
                    appKey: params.appKey,
                    query: {
                        parent_connection_id: params.connectionId
                    },
                    autoInitFiveEvent: false,
                    onReceiveMessage: params.onReceiveMessage
                });
                return instance;
            };
        })();
        return __webpack_exports__;
    })());

//# sourceMappingURL=realsee-telemetry.umd.js.map